module.exports = __webpack_public_path__ + "fonts/montserrat-regular-webfont.362ffe720ba40be359302cab7f83c517.eot?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.eot
// module id = 286
// module chunks = 9